import { render, staticRenderFns } from "./rules.vue?vue&type=template&id=999bf1fe&scoped=true&"
import script from "./rules.vue?vue&type=script&lang=js&"
export * from "./rules.vue?vue&type=script&lang=js&"
import style0 from "./rules.vue?vue&type=style&index=0&id=999bf1fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999bf1fe",
  null
  
)

export default component.exports